// extracted by mini-css-extract-plugin
export var container = "styles-module__container___BRsL5";
export var image = "styles-module__image___Cmr8Q";
export var innerContainer = "styles-module__innerContainer___wNz6q";
export var header = "styles-module__header___pORjo";
export var description = "styles-module__description___kdfhC";
export var disclaimer = "styles-module__disclaimer___BN0HY";